(function () {
    'use strict';

    // @ngInject
    Services.Fingerprint = function Fingerprint($window, $q) {
        var Fingerprint2 = $window.Fingerprint2;
        var cachedFingerprint = null;

        return function calcFingerprint() {
            var defer = $q.defer();

            try {

                if (cachedFingerprint) { // check if already saved the result.
                    defer.resolve(cachedFingerprint);
                } else if (Services.Fingerprint._cachedResult) { // check if the calcaulation was done before the service was initialized
                    cachedFingerprint = Services.Fingerprint._cachedResult;
                    delete Services.Fingerprint._cachedResult;
                    defer.resolve(cachedFingerprint);
                } else { // last resort... calculate it
                    var fp = new Fingerprint2({excludeUserAgent: true, excludeTimezoneOffset: true});

                    fp.get(function (result) {
                        cachedFingerprint = result;
                        defer.resolve(result);
                    }.bind(this));
                }
            } catch (e) {
                // We don't wanna fail the running process in case the fingerprint fails
                defer.resolve(cachedFingerprint);
            }

            return defer.promise;
        };
    };

}());
